export default __webpack_public_path__ + "3b77301c2d448e1441049eb4e85b6c90.svg";